import { Box, FormMaskedTextField, FormPasswordField, FormTextField } from "@luce/ui";

import { CARD_NUMBER_MASK, EXPIRY_MASK } from "./lib";

export const CreditCardFields = ({ disabled }: { disabled?: boolean }) => (
  <Box className="gap-spacing-md flex flex-col">
    <FormTextField name="name" label="Cardholder name" placeholder="John Doe" disabled={disabled} />
    <FormMaskedTextField
      name="number"
      label="Credit card number"
      placeholder="**** **** **** ****"
      mask={CARD_NUMBER_MASK}
      disabled={disabled}
    />
    <Box className="gap-spacing-sm flex flex-row">
      <FormMaskedTextField
        name="expDate"
        label="Exp. date"
        placeholder="MM/YYYY"
        mask={EXPIRY_MASK}
        containerClassName="min-w-0 basis-1/2 flex-1"
        disabled={disabled}
      />

      <FormPasswordField
        name="cvc"
        label="CVC"
        placeholder="3 or 4 digit"
        // Not phone-pad: under secure entry our web TextInput drops it, so phones show letters
        keyboardType="number-pad"
        maxLength={4}
        containerClassName="min-w-0 basis-1/2 flex-1"
        inputClassName="min-w-0"
        disabled={disabled}
      />
    </Box>
  </Box>
);
